import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ANIMATE_SELECTOR = ".reveal, .animate-cardIn, .animate-fadeInSoft";

const shouldPlayImmediately = (el) =>
  Boolean(
    el.closest(".hero-section") ||
      el.closest(".auth-page") ||
      el.closest(".landing-page > header")
  );

export default function RevealObserver() {
  const location = useLocation();

  useEffect(() => {
    const observed = new WeakSet();

    const markInView = (el) => {
      el.classList.add("is-inview");
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            markInView(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -5% 0px" }
    );

    const observeAll = () => {
      document.querySelectorAll(ANIMATE_SELECTOR).forEach((el) => {
        if (shouldPlayImmediately(el)) {
          markInView(el);
        }

        if (observed.has(el)) return;
        observed.add(el);
        observer.observe(el);

        const rect = el.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const inView = rect.top < vh && rect.bottom > 0;
        if (inView) markInView(el);
      });
    };

    observeAll();

    const mo = new MutationObserver(() => observeAll());
    mo.observe(document.body, { childList: true, subtree: true });

    return () => {
      mo.disconnect();
      observer.disconnect();
    };
  }, [location.pathname]);

  return null;
}
